import { createIcon } from './_icon';

const BellSolidIcon = createIcon(() => (
	<svg width="1em" height="1em" fill="none" viewBox="0 0 24 24">
		<path
			fill="currentColor"
			fill-rule="evenodd"
			d="M12 2a7.853 7.853 0 0 0-7.784 6.815L2.858 19h4.496c.904 1.748 2.607 3 4.646 3 2.039 0 3.742-1.252 4.646-3h4.496L19.784 8.815A7.853 7.853 0 0 0 12 2Zm2.222 17H9.778c.61.637 1.399 1 2.222 1s1.613-.363 2.222-1Z"
			clip-rule="evenodd"
		/>
	</svg>
));

export default BellSolidIcon;
